var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1721281841079,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 6873,
    id: "mx_n_1721281841080",
    width: 256,
    height: 256,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M766.4 929.7c-15.7 0-30.7-6.5-41.9-13.2l-1.2-0.7L541 770.6l-81.3 84.9c-11.5 12.4-25.8 27.7-53.8 27.7h-21.3l15-244.2 293.7-285.2-380.6 259.3-202.8-69.3c-26.8-8.3-42.9-24.5-44-44.5-0.8-13.3 5-38.7 51.7-59l0.3-0.1 753.7-313.3c22-10.5 45.2-8.7 62.2 4.8 10 7.9 31.8 32 19.9 83.8L825.2 867.1c-5.8 30.1-18.5 49.7-37.7 58.3-7 3.1-14.1 4.3-21.1 4.3z m-20.3-46.9c10.7 6.2 19.8 8.4 25.1 6 6.3-2.8 11.7-13.6 14.8-29.4L914.5 207l0.1-0.3c5.7-24.4 0.7-38.6-5.8-43.8-6.6-5.3-15.6-2.2-20.3 0.2l-1.1 0.5L133.3 477c-20.9 9.1-26.8 17.5-27.5 19.9 0.9 1.5 5.1 5.4 16 8.8l0.6 0.2 184.2 62.9 439.7-299.4 0.2-0.1c21.6-14 44.5-13.9 55.8 0.2 7.1 8.9 9.7 24.8-6.4 40.5l-0.1 0.1-357.1 346.8-10.7 174c0.8-0.8 1.6-1.7 2.5-2.7l0.2-0.2 106.6-111.4 208.8 166.2z",
    fill: "#ffffff",
    "p-id": 6874
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.33b75e514a1ddb58da43b5f775af3aa8.svg";
export { ForwardRef as ReactComponent };